import { useContentOverflow, useUk } from '../../../hooks'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './CompanyName.module.css'

/**
 * Component to display current company name
 */
function CompanyName({
  className = styles.CompanyName,
  textClassName = styles.text,
}) {
  const { name } = useUk()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  return (
    <span className={className}>
      <FloatingTooltip content={name} disabled={!overflow}>
        <Text className={textClassName} ref={setContentOverflowRef}>
          {name}
        </Text>
      </FloatingTooltip>
    </span>
  )
}

export default CompanyName
